export const navigation = [
  {
    label: 'Workspace',
    items: [
      { to: '/dashboard', label: 'Overview', icon: 'fa-chart-pie', end: true },
      { to: '/dashboard/payment-vendors', label: 'Vendor Gateway', icon: 'fa-building-columns' }
    ]
  },
  {
    label: 'Config',
    items: [
      { to: '/dashboard/bank-routing', label: 'Bank routing', icon: 'fa-route' },
      { to: '/dashboard/qris-configs', label: 'QRIS channels', icon: 'fa-qrcode' },
      { to: '/dashboard/qris-ext-configs', label: 'QRIS Callback', icon: 'fa-code-branch' },
      { to: '/dashboard/inquiry-configs', label: 'Inquiry routes', icon: 'fa-magnifying-glass-dollar' },
      { to: '/dashboard/api-callback', label: 'API callbacks', icon: 'fa-plug' },
      { to: '/dashboard/ip-whitelisting', label: 'IP allowlist', icon: 'fa-shield-halved' }
    ]
  },
  {
    label: 'Activity',
    items: [
      { to: '/dashboard/inquiry-callback', label: 'Inquiry activity', icon: 'fa-receipt' },
      { to: '/dashboard/global-callback-logs', label: 'Callback activity', icon: 'fa-arrow-right-arrow-left' },
      { to: '/dashboard/api-traffic', label: 'API traffic', icon: 'fa-wave-square' }
    ]
  },
  {
    label: 'Security',
    admin: true,
    items: [
      { to: '/dashboard/security', label: 'Security Event', icon: 'fa-shield-virus' }
    ]
  },
  {
    label: 'Admin',
    admin: true,
    items: [
      { to: '/dashboard/users', label: 'Users', icon: 'fa-users' },
      { to: '/dashboard/token', label: 'Sessions', icon: 'fa-key' },
      { to: '/dashboard/api-doc', label: 'API documentation', icon: 'fa-book-open' }
    ]
  }
]

export const pageTitles = {
  '/dashboard': 'Payment overview',
  '/dashboard/users': 'User management',
  '/dashboard/token': 'Active sessions',
  '/dashboard/profile': 'Account profile',
  '/dashboard/payment-vendors': 'Vendor Gateway',
  '/dashboard/bank-routing': 'Bank routing',
  '/dashboard/ip-whitelisting': 'IP allowlist',
  '/dashboard/qris-configs': 'QRIS configuration',
  '/dashboard/qris-ext-configs': 'Callback configuration',
  '/dashboard/inquiry-configs': 'Inquiry configuration',
  '/dashboard/api-callback': 'API callback configuration',
  '/dashboard/inquiry-callback': 'Inquiry activity',
  '/dashboard/global-callback-logs': 'Callback activity',
  '/dashboard/api-traffic': 'API traffic',
  '/dashboard/security': 'Security Event',
  '/dashboard/api-doc': 'API documentation'
}